import { useState } from "react";

import { useEffect } from "react";

export const useInViewPort = (
  ref: React.RefObject<HTMLElement>,
  options: IntersectionObserverInit = {
    rootMargin: "0px",
    threshold: 0.1,
  },
) => {
  const [isInViewPort, setIsInViewPort] = useState(false);

  useEffect(() => {
    if (!ref?.current) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      console.log(entry);
      setIsInViewPort(entry.isIntersecting);
    }, options);

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref, options]);

  return isInViewPort;
};
